export const SECTORS = [
  { value:"", label:"Select your sector..." },
  // Construction & Contracting
  { value:"gc", label:"🏗️  General Contractor", sector:"construction" },
  { value:"roofing", label:"🏠  Roofing", sector:"construction" },
  { value:"painting", label:"🎨  Painting & Coatings", sector:"construction" },
  { value:"electrical", label:"⚡  Electrical", sector:"construction" },
  { value:"plumbing", label:"🔧  Plumbing", sector:"construction" },
  { value:"hvac", label:"❄️  HVAC / Mechanical", sector:"construction" },
  { value:"framing", label:"🪵  Framing / Carpentry", sector:"construction" },
  { value:"concrete", label:"🏛️  Concrete & Masonry", sector:"construction" },
  { value:"demolition", label:"💥  Demolition", sector:"construction" },
  { value:"landscaping", label:"🌿  Landscaping / Hardscape", sector:"construction" },
  { value:"fabrication", label:"🏭  Custom Fabrication / Themed Environments", sector:"construction" },
  { value:"restoration", label:"🔨  Fire / Water Restoration Contractor", sector:"construction" },
  { value:"solar", label:"☀️  Solar Installation", sector:"construction" },
  { value:"paving", label:"🛣️  Paving / Asphalt", sector:"construction" },
  // Real Estate
  { value:"re_investor", label:"🏢  Real Estate Investor (Residential)", sector:"realestate" },
  { value:"re_commercial", label:"🏬  Commercial Property Owner / Investor", sector:"realestate" },
  { value:"re_flipper", label:"🔄  Fix & Flip / Renovation Investor", sector:"realestate" },
  { value:"re_rental", label:"🏘️  Rental Portfolio Owner", sector:"realestate" },
  { value:"re_developer", label:"🏙️  Real Estate Developer", sector:"realestate" },
  { value:"re_hoa", label:"🏠  HOA / Condo Association", sector:"realestate" },
  { value:"re_broker", label:"🤝  Real Estate Brokerage", sector:"realestate" },
  { value:"re_pm", label:"📋  Property Management Company", sector:"realestate" },
  // Other
  { value:"other", label:"⚙️  Other / Specialty", sector:"other" },
];

export const SECTOR_GROUPS = {
  construction: "Construction & Contracting",
  realestate: "Real Estate",
  other: "Other",
};